import { render } from "./UnitStatuses.vue?vue&type=template&id=e3128ab2"
import script from "./UnitStatuses.vue?vue&type=script&lang=js"
export * from "./UnitStatuses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__